<div class="app-isf-ocr-quick-fix-header">
  <div class="app-isf-ocr-quick-fix-header__card">
    <img src="assets/icons/icon_circled_flag_blue.svg" alt="circled flag" />
    <div class="app-isf-ocr-quick-fix-header__content">
      <p class="app-isf-ocr-quick-fix-header__content__title">{{ "EXCELLENT" | translate }}</p>
      <p class="app-isf-ocr-quick-fix-header__content__description">{{ "LABELS.OCR_QUICK_FIX_DESCRIPTION" | translate }}</p>
    </div>
    <div class="app-isf-ocr-quick-fix-header__actions">
      <button class="app-isf-ocr-quick-fix-header__actions__clear-button btn btn-outline-bordered" (click)="onClearAll()">
        <img src="assets/icons/icon_trash.svg" alt="trash" />
        <span>{{ "BUTTON.CLEAR_ALL" | translate | titlecase }}</span>
      </button>
      <button *ngIf="isShowQuickFix" class="app-isf-ocr-quick-fix-header__actions__fix-button btn btn-link-filled" (click)="onQuickFix()">
        <img src="assets/icons/icon_wrench.svg" alt="wrench" />
        <span>{{ "BUTTON.QUICK_FIX" | translate | titlecase }}</span>
      </button>
    </div>
  </div>
</div>
